// style
import './style/style.css'
// hook and controller
import useGetData from '../../hook/getData';
import { GetSettings } from '../../services/client/settings/getSettings';
import { useEffect } from 'react';
import { IconAddressBook, IconMapBolt } from '@tabler/icons-react';
const AboutUs = () => {
    const { data: settings } = useGetData(['settings'], GetSettings)
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <>
            <section className="contactus bg-white py-5">
                <div className="container">
                    <div className="row gy-4 overflow-hidden align-items-center">
                        <div className="col-md-5 text-start" data-aos="fade-up">
                            <img src={require('./../../assets/media/banner/aboutUsNew.webp')} alt="about" className="about-img" />
                        </div>
                        <div className="col-md-7" data-aos="fade-right">
                            <h1 className='fw-bold card-title h4'>درباره ما</h1>
                            {settings?.data ? (settings.data) : (
                                <>
                                    <p className='mt-3 line-30 card-text mb-2'>
                                        آریا استیل راد با تکیه بر دانش فنی، تجربه تخصصی و بهره‌گیری از نیروهای متخصص، فعالیت خود را با هدف طراحی و تولید تجهیزات آشپزخانه صنعتی باکیفیت آغاز کرده است. ما بر این باوریم که کیفیت، نوآوری و رضایت مشتری سه اصل اساسی در مسیر رشد و موفقیت هستند؛ از همین رو تمامی محصولات با استفاده از متریال درجه‌یک، فناوری روز و استانداردهای تولید طراحی و ساخته می‌شوند.
                                        حوزه تخصصی آریا استیل راد شامل طراحی، ساخت و اجرای انواع باربیکیوهای مدرن، گریل‌های تخصصی، تجهیزات پخت‌وپز، تجهیزات آماده‌سازی، تجهیزات برودتی و سایر تجهیزات موردنیاز آشپزخانه‌های صنعتی، رستوران‌ها، فست‌فودها، کافه‌ها و مراکز تهیه غذا است. ما تلاش می‌کنیم محصولاتی ارائه دهیم که علاوه بر کیفیت و دوام بالا، از طراحی کاربردی و ظاهری مدرن نیز برخوردار باشند.
                                    </p>
                                    <h6 className='mt-2 fw-bold'>آدرس  :</h6>
                                    <ul className='list-group px-0'>
                                        <li className='list-group-item px-0'>
                                            <IconMapBolt className='me-1' />
                                            تهران-فردوسیه شهریار-بلوار امیرکبیر-بلوار امام خمینی-پلاک 1015
                                        </li>
                                        <li className='list-group-item px-0'>
                                            <IconAddressBook className='me-1' />
                                            شماره تماس : 09127657763
                                        </li>
                                    </ul>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AboutUs;